import Cookies from "universal-cookie";

const cookies = new Cookies();

const cookieOptions = {
  path: "/",
  secure: window.location.protocol === "https:",
  sameSite: "strict",
};

export const setCookie = (key, value, days = 1) => {
  const expires = new Date();
  expires.setDate(expires.getDate() + days);
  cookies.set(key, value, { ...cookieOptions, expires });
};

export const getCookie = (key) => cookies.get(key);

export const removeCookie = (key) => cookies.remove(key, { path: "/" });

export const getToken = () => {
  const token = getCookie("__adminToken");
  return token ? token.replaceAll("%20", "") : null;
};

export const setToken = (token) => {
  setCookie("__adminToken", token, 1);
};

export const removeToken = () => {
  removeCookie("__adminToken");
};

export const clearCookies = () => {
  const allCookies = cookies.getAll();
  for (const cookie in allCookies) {
    removeCookie(cookie);
  }
};
